/* eslint-disable @typescript-eslint/no-explicit-any */
import cx from 'classnames';
import React, { FC } from 'react';

import { bem } from '../../../../core/design/bem';
import { Workshop } from '../../../../types/workshop.types';
import { WorkshopAction } from '../../workshop-templates/actions/action.type';
import { AccordionActions } from './AccordionActions';
import './AccordionCard.scss';
import { AccordionDetails } from './AccordionDetails';

const css = bem('WorkshopAccordionCard');

type AccordionCardProps = {
  actionsConfig: Record<string, any>;
  showSpeakers: boolean;
  speakersConfig: Record<string, any>;
  workshop: Workshop;
  allowOverlappingSessions?: boolean;
  tagField?: string;
  dateConfig?: Record<string, any>;
  showTimezone?: boolean;
  actions?: WorkshopAction[];
  showIcons?: boolean;
  showDay?: boolean;
  showDuration?: boolean;
  showEndTime?: boolean;
};

const AccordionCard: FC<AccordionCardProps> = (props: AccordionCardProps) => {
  const {
    workshop,
    showSpeakers,
    speakersConfig,
    actionsConfig,
    tagField,
    dateConfig,
    showTimezone,
    showIcons,
    showDay = false,
    showDuration,
    showEndTime = true,
    ...itemProps
  } = props;
  const { _id, category } = workshop;

  return (
    <div className={css({ _id, category })}>
      <div className={css('accordion')}>
        <AccordionDetails
          workshop={workshop}
          showSpeakers={showSpeakers}
          speakersConfig={speakersConfig}
          tagField={tagField}
          dateConfig={dateConfig}
          showTimezone={showTimezone}
          showIcons={showIcons}
          showDay={showDay}
          showDuration={showDuration}
          showEndTime={showEndTime}
        />
      </div>
      {!!itemProps.actions?.length && (
        <div className={css('actions')}>
          <AccordionActions
            workshop={workshop}
            actionsConfig={actionsConfig}
            itemProps={itemProps}
          />
        </div>
      )}
    </div>
  );
};
AccordionCard.defaultProps = {
  allowOverlappingSessions: false,
  tagField: undefined,
};

export default AccordionCard;
